import { render, staticRenderFns } from "./ShipExperiencePage.vue?vue&type=template&id=50c1753e"
import script from "./ShipExperiencePage.vue?vue&type=script&lang=js"
export * from "./ShipExperiencePage.vue?vue&type=script&lang=js"
import style0 from "./ShipExperiencePage.vue?vue&type=style&index=0&id=50c1753e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports